import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * "pin-2" nav icon (Figma node 28437:53846): a person with a location pin, outline only.
 * Used by the "My Site" menu item. Stroke is `currentColor` so the nav item colors it in
 * light and dark themes, like the other menu icons.
 */
export const Pin2 = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 14C20.2927 14.6904 22 16.1241 22 17.7807C22 20.111 17.5228 22 12 22C6.47715 22 2 20.111 2 17.7807C2 16.1241 3.70729 14.6904 7 14M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM12 12V18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
